import { render, staticRenderFns } from "./IsciPodrobnosti.vue?vue&type=template&id=8a09557c&scoped=true"
import script from "./IsciPodrobnosti.vue?vue&type=script&lang=js"
export * from "./IsciPodrobnosti.vue?vue&type=script&lang=js"
import style0 from "./IsciPodrobnosti.vue?vue&type=style&index=0&id=8a09557c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a09557c",
  null
  
)

export default component.exports